import React, { useState, useEffect } from 'react';
import fetch from 'cross-fetch';
import { translateResourceString } from '../util/translationUtility';
import { capitalize } from 'lodash';

const BraintreeAchPayment = ({
    braintreeUsBankAccountEndpoint,
    onSelect,
    onError
}) => {

    const [usBankAccounts, setUsBankAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchUsBankAccounts();
    }, []);

    const fetchUsBankAccounts = () => {

        // Don't run this server-side
        if (typeof window === 'undefined') {
            console.log('prevented fetching accounts')
            return;
        }

        setIsLoading(true);

        fetch(braintreeUsBankAccountEndpoint,
            {
                method: 'GET',
                headers: { "X-Requested-With": 'fetch' },
                credentials: 'same-origin'
            })
            .then((response) => {
                if (response.ok)
                    return response.json();
                throw new Error(`${response.status}: ${response.statusText}`)
            })
            .then((usBankAccounts) => {
                setUsBankAccounts(usBankAccounts);
                setIsLoading(false);
                if(usBankAccounts.length > 0) {
                    onSelect(usBankAccounts[0]);
                }
            }).catch((error) => {
                setIsLoading(false);
                console.error(error);
                onError(translateResourceString("/MyAccountPage/InvoicePayments/BraintreeAchPayment/ErrorLoadingAchAccount"));
            });
    }

    const goToWallet = () => {
        window.$('a[href="#wallet"]').tab('show');
    }

    return (
        <div>
            {isLoading
                ?
                <div style={{ paddingBottom: 10 }}><span className="fas fa-spinner fa-spin" /></div>
                :
                <React.Fragment>
                    <div className="row">
                        {usBankAccounts.map(account => (
                            <div key={account.Token} className="col-12">           
                                <div className="us-bank-account mb-2" onClick={() => onSelect(account)} >
                                    <div className="logo">
                                        <i className="fa fa-2x fas fa-university mr-2"></i>                                    
                                    </div>
                                    <div className="label">
                                        <h5 className="my-0 us-bank-account-label">{capitalize(account.Type)} {translateResourceString("/MyAccountPage/InvoicePayments/BraintreeAchPayment/EndingIn")} {account.Last4}</h5>
                                        {account.BankName}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p><button className="btn btn-cc-gray" onClick={(e) => { e.preventDefault(); goToWallet() } }>{translateResourceString("/MyAccountPage/InvoicePayments/BraintreeAchPayment/AddNewACHAccount")}</button></p>
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
}

export default BraintreeAchPayment;